/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * A T-mobile customm design legalText component.
 * A tmo-legal-text component can be used overall the application to display the legal disclaimer
 * which is fetched from AEM
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { LegalText } from './models/legal-text.interface';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
@Component({
  selector: 'tmo-legal-text-authorable',
  templateUrl: './legal-text-authorable.component.html',
})
export class LegalTextAuthorableComponent
  extends AuthorableComponent<Object>
  implements OnInit, OnDestroy
{
  @Input() public showInTablet: boolean;
  @Input() public showInMobile: boolean;
  @Input() public showInDesktop: boolean;
  @Input() public legalCopy: String;
  @Input() public displayType: String;
  @Input() public css: string;
  public legalItems: LegalText;
  public isLegalTextExist: boolean = false;

  /**
   * Whenever this component needs some value to be instantiated on load then
   * values of its properties are initialised in the constructor
   * @returns void
   */
  constructor() {
    super();
  }

  /**
   * Called whenever this component is invoked from parent component
   * @returns void
   */
  public ngOnInit(): void {}

  /**
   * Set the legal text data
   * @returns void
   */
  public setData(data: LegalText): void {
    if (data && data.items && data.items.length > 0) {
      this.legalItems = data;
      this.isLegalTextExist = true;
    } else {
      this.isLegalTextExist = false;
    }

    if (this.validate(data)) {
      this.legalCopy = data.legalCopy ? data.legalCopy.en : data.items[0].legalCopy;
      this.displayType = data.displayType;
    }

    // Assign optionals
    this.css = data.css || '';
    this.showInTablet = data.showInTablet || true;
    this.showInMobile = data.showInMobile || true;
    this.showInDesktop = data.showInDesktop || true;
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data
   */
  public validate(data: LegalText): boolean {
    if (
      !data ||
      (!data.legalCopy && !(data.items && data.items.length > 0 && data.items[0].legalCopy))
    ) {
      throw new Error(`Invalid options for legalText data`);
    }
    return true;
  }

  /**
   * Destroys all the subscriptions .
   * @returns void
   */
  public ngOnDestroy(): void {}
}
